export const SOURCE = {
    EXTERNAL: "external",
    INTERNAL: "internal"
}

export const SELECTION_TYPE = {
    MARK: "mark"
}

export const STEP_INPUT_TYPE = {
    SELECT_FROM_ENUM: "select_from_enum"
}